export enum CurrentMobileView {
  Hierarchy = "Hierarchy",
  Sets = "Sets",
  Detail = "Detail",
  Summary = "Summary",
}